import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Box, Typography } from "@mui/material";
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

interface Props {
  open: boolean,
  handleClose: () => void,
  handleConfirm: () => void,
  title: string,
  message: string,
  confirmText?: string,
  cancelText?: string,
  confirmColor?: "primary" | "error" | "success" | "warning" | "info" | "secondary",
  showWarningIcon?: boolean,
  useHtmlMessage?: boolean,
}

export const ModalConfirm = (props: Props) => {
  const {
    open,
    handleClose,
    handleConfirm,
    title,
    message,
    confirmText = "Confirm",
    cancelText = "Cancel",
    confirmColor = "primary",
    showWarningIcon = false
  } = props;
  return (
    <Dialog open={open} onClose={handleClose} PaperProps={{ sx: { borderRadius: 3, minWidth: 350 } }}>
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 700, fontSize: 20 }}>
        {showWarningIcon && (
          <WarningAmberRoundedIcon color="warning" sx={{ fontSize: 40, mb: 1 }} />
        )}
        <Box>{title}</Box>
      </DialogTitle>
      <DialogContent>
        { props.useHtmlMessage ? (
          <Typography component="div" sx={{ textAlign: 'center', fontSize: 16, mt: 1 }}  dangerouslySetInnerHTML={{ __html: message }} />
        ):
        (
          <Typography sx={{ textAlign: 'center', fontSize: 16, mt: 1 }} >{message}</Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button onClick={handleConfirm} variant="contained" color={confirmColor} sx={{ minWidth: 100, ml: 1 }}>
          {confirmText}
        </Button>
        <Button onClick={handleClose} variant="outlined" color="inherit" sx={{ minWidth: 100 }}>
          {cancelText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalConfirm;